DigiTickets.EntryRequirement = Object.freeze({
    REQUIRED: 'Required',
    OPTIONAL: 'Optional',
    NOT_ALLOWED: 'Not Allowed'
});
